import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { StorageService } from './storage.service';

import { Diet, Meal } from '../interfaces/diet';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DietService {
  apiUrl = environment.apiUrl;
  DIET_apiUrl = environment.apiUrl + '/diet';
  MEAL_apiUrl = environment.apiUrl + '/meal/';

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  // CRUD de Dietas:

  createDiet(
    diet: Pick<
      Diet,
      | 'name'
      | 'description'
      | 'userId'
      | 'allowCheatMeals'
      | 'totalWeeks'
      | 'periodCheatMeals'
      | 'water'
    >
  ): Observable<Diet> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<Diet>(
      this.DIET_apiUrl,
      {
        ...diet,
      },
      { headers: httpHeaders }
    );
  }

  getUserDietHistory(userId: string): Observable<Diet[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<Diet[]>(
      this.apiUrl + '/user/' + userId + '/diet-history',
      { headers: httpHeaders }
    );
  }

  updateDiet(diet: Diet): Observable<Diet> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.patch<Diet>(
      this.DIET_apiUrl + '/' + diet.id,
      {
        ...diet,
      },
      { headers: httpHeaders }
    );
  }

  finishDiet(dietId: number): Observable<object | null> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<object | null>(
      this.DIET_apiUrl + '/' + dietId + '/finish',
      {},
      { headers: httpHeaders }
    );
  }

  // CRUD de Comidas:

  createMeal(
    meal: Pick<Meal, 'dietId' | 'title' | 'description' | 'order'>
  ): Observable<Meal> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<Meal>(
      this.DIET_apiUrl + '/' + meal.dietId + '/meal',
      {
        title: meal.title,
        description: meal.description,
        order: meal.order,
      },
      { headers: httpHeaders }
    );
  }

  getMealsFromDiet(dietId: number): Observable<Meal[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<Meal[]>(this.DIET_apiUrl + '/' + dietId + '/meal', {
      headers: httpHeaders,
    });
  }

  updateMeal(meal: Meal): Observable<Meal> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.patch<Meal>(
      this.DIET_apiUrl + '/' + meal.dietId + '/meal/' + meal.id,
      {
        title: meal.title,
        description: meal.description,
        order: meal.order,
      },
      { headers: httpHeaders }
    );
  }

  updateMealOrder(meal: Meal): Observable<Meal> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.patch<Meal>(
      this.DIET_apiUrl + '/' + meal.dietId + '/meal/' + meal.id,
      {
        order: meal.order,
      },
      { headers: httpHeaders }
    );
  }

  deleteMeal(meal: Meal): Observable<object | null> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.delete<null>(
      this.DIET_apiUrl + '/' + meal.dietId + '/meal/' + meal.id,
      { headers: httpHeaders }
    );
  }

  importMeal(meal: Meal, dietId: number): Observable<object | null> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<null>(
      this.DIET_apiUrl + '/' + dietId + '/import/meal/' + meal.id,
      {},
      { headers: httpHeaders }
    );
  }

  getDietProgretion(dietId: number, userId: number): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<void>(
      `${this.apiUrl}/user/${userId}/diet/${dietId}/progretion`,
      {},
      { headers: httpHeaders }
    );
  }

  getDietCalendar(dietId: number): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<void>(`${this.DIET_apiUrl}/${dietId}/status`, {
      headers: httpHeaders,
    });
  }

  getDietDetail(dietId: number, date: string) {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<void>(
      `${this.DIET_apiUrl}/${dietId}/track?date=${date}`,
      {
        headers: httpHeaders,
      }
    );
  }
}
